export function removeDisturbingElm(root){
    try {
        let feedback = document.getElementById('_hj_feedback_container')
        if(feedback){
            feedback.style = 'display:none;'
        }
        
        let beacon = document.getElementById('beacon-container')
        if(beacon){
            beacon.style = 'display:none;'
        }

        root.$refs.mobScrollUp.active = false
    } catch (error) {
        console.error(error);  
    }
    
}


export function addDisturbingElm(root){
    try {
        let feedback = document.getElementById('_hj_feedback_container')
        
        if(feedback){
            feedback.style = 'display:block;'
        }
        
        let beacon = document.getElementById('beacon-container')
      
        if(beacon){
            beacon.style = 'display:block;'
        }

        root.$refs.mobScrollUp.active = true
    } catch (error) {
        console.error(error); 
    }
    
}


// WEBPACK FOOTER //
// ./resources/js/mixins/manageDisturbingElm.js